import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=9684b7d8&scoped=true"
import script from "./CampaignStatus.vue?vue&type=script&lang=ts"
export * from "./CampaignStatus.vue?vue&type=script&lang=ts"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=9684b7d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9684b7d8",
  null
  
)

export default component.exports